import { config } from '@/config';
import { EMBEDDED_APP_STATUS } from '@/constants/enum';
import EmbeddedSaveBar from './EmbeddedSaveBar';
import NonembeddedSaveBar from './NonEmbeddedSaveBar';

interface IAppSaveBar {
  open: boolean;
  loading?: boolean;
  disabled?: boolean;
  onSave: () => void;
  onDiscard: () => void;
  disableDiscard?: boolean;
}

const AppSaveBar = ({ open, loading, disabled, onSave, onDiscard, disableDiscard }: IAppSaveBar) => {
  if (config.embedded === EMBEDDED_APP_STATUS.EMBEDDED) {
    return <EmbeddedSaveBar open={open} loading={loading} disabled={disabled} onSave={onSave} onDiscard={onDiscard} disableDiscard={disableDiscard} />;
  } else {
    return (
      <NonembeddedSaveBar
        open={open}
        loading={loading}
        disabled={disabled}
        onSave={onSave}
        onDiscard={onDiscard}
        disableDiscard={disableDiscard}
      />
    );
  }
};

export default AppSaveBar;
